export default __webpack_public_path__ + "static/media/105620d8-290b-4fce-b484-17f679f88671.f1bb9579.mp4";